import * as React from 'react';
import '../../../../../ScreenReaderOnly/index.js';
import '../../../../../Typography/index.js';
import { Typography } from '../../../../../Typography/Typography.js';
import { ScreenReaderOnly } from '../../../../../ScreenReaderOnly/ScreenReaderOnly.js';

var AsteriskRequiredIndicator = function AsteriskRequiredIndicator(_ref) {
  var screenReaderText = _ref.screenReaderText;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    tag: "span",
    variant: "body-s-strong",
    "aria-hidden": "true"
  }, "*"), /*#__PURE__*/React.createElement(ScreenReaderOnly, null, screenReaderText));
};
var LabelSuffixComponent = function LabelSuffixComponent(_ref2) {
  var suffixIndicator = _ref2.suffixIndicator;
  if (!suffixIndicator) return null;
  var variant = suffixIndicator.variant;
  if (variant === 'text') {
    var text = suffixIndicator.text;
    return /*#__PURE__*/React.createElement(Typography, {
      tag: "span",
      variant: "body-s",
      textColor: "base.subtle"
    }, "(".concat(text, ")"));
  }
  var screenReaderText = suffixIndicator.screenReaderText;
  return /*#__PURE__*/React.createElement(AsteriskRequiredIndicator, {
    screenReaderText: screenReaderText
  });
};
LabelSuffixComponent.displayName = 'LabelSuffix';
var LabelSuffix = /*#__PURE__*/React.memo(LabelSuffixComponent);

export { LabelSuffix, LabelSuffixComponent };
//# sourceMappingURL=LabelSuffix.js.map
